<template>
  <div class="bg-white">
    <div class="container">
      <div class="nav-wrapper">
        <div class="nav">
          <vs-row>
            <vs-col class="vs-lg-4 gb-logo" vs-justify="space-between">
              <a href="/user/dashboard"
                ><img src="@/assets/images/aboutUs/gb-logo.png" alt="gb-logo"
              /></a>
            </vs-col>
            <vs-col class="vs-lg-8 nav-links">
              <!-- <a class="links" href="#">Services</a>
              <a class="links" href="#">Resources</a>
              <a class="links" href="#">Company</a>
              <a class="links" href="#">Blog</a>
              <a class="links" href="#">Contact Us</a> -->
              <div v-if="!isUserLoggedIn">
              <a :href="`${constants.apiHost}/oauth`" class="sign-btn" 
                >Sign In
              </a>
              </div>
              <div v-else>
                <ProfileDropDown />
              </div>
            </vs-col>
          </vs-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileDropDown from "@/layouts/components/user-dashboard/navbar/components/ProfileDropDown.vue";
import constants from '@/constants';

export default {
  name: "Navbar",
  components: { ProfileDropDown },
  data() {
    return {
      constants
    }
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
  },
};
</script>

<style scoped>
.nav-wrapper {
  padding: 20px 50px;
}
.bg-white {
  background: white;
}
.links {
  padding-right: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #5d6473;
}
.nav {
  text-align: center;
}
.nav-links {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.sign-btn {
  border: 1px solid orange;
  border-radius: 20px;
  padding: 10px 35px;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #282c4b;
}
img {
  display: flex;
}
.gb-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1200px) {
  .nav-wrapper {
  padding: 12px 4px;
}
img {
  height: 40px;
}
.links {
  display: none;
}
.nav-links {
  justify-content: flex-end;
}
}
</style>